import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Nav } from 'react-bootstrap-5';
import NewActivityForm from './activity_forms/new_activity_form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faListTimeline } from '@fortawesome/pro-solid-svg-icons';
import ActivityHistory from './activity_history';
import { connect } from 'react-redux';
import { addActivity, removeActivity, updateActivity } from './store/actions/activities';

const TAB_NEW = 'new';
const TAB_LOG = 'log';

function ActivityLog({ callListId, callTemplates, activities, recordId, recordType }) {
  const [tab, setTab] = useState(TAB_NEW);

  const completedActivities = activities.filter(activity => !activity.isTask || activity.completedAt);

  return (
    <Card>
      <Card.Header className="border-bottom-0">
        <h5 className="fw-bolder mb-0">Activity Log</h5>
      </Card.Header>
      <Nav activeKey={tab} variant="tabs" onSelect={setTab}>
        <Nav.Item>
          <Nav.Link className="border-start-0" eventKey={TAB_NEW}>
            <FontAwesomeIcon icon={faPlusCircle} />
            Create New
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey={TAB_LOG}>
            <FontAwesomeIcon icon={faListTimeline} />
            History ({completedActivities.length})
          </Nav.Link>
        </Nav.Item>
      </Nav>
      {tab === TAB_NEW && (
        <NewActivityForm
          callListId={callListId}
          callTemplates={callTemplates}
          recordId={recordId}
          recordType={recordType}
        />
      )}
      {tab === TAB_LOG && (
        <ActivityHistory activities={completedActivities} />
      )}
    </Card>
  );
}

ActivityLog.propTypes = {
  activities: PropTypes.array.isRequired,
  callListId: PropTypes.number.isRequired,
  callTemplates: PropTypes.array.isRequired,
  recordId: PropTypes.number.isRequired,
  recordType: PropTypes.string.isRequired
};

const mapStateToProps = ({ activities }) => ({ activities });
export default connect(mapStateToProps, { addActivity, removeActivity, updateActivity })(ActivityLog);
